/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal } from "semantic-ui-react";
import { useEffect, useState } from "react";
import ReferenceEntry from "../../datatypeComponents/ReferenceEntry";
import createEvidenceDisplay from "../compositionResourceFunctions/createEvidenceDisplay";
import { useSelector } from "react-redux";
import { selectEvidenceTableMap } from "../../slices/evidenceTableMap/evidenceTableMapSlice";

const getEvidenceDisplay = (resourceDictionary, startingValue) => {

  if (startingValue) {
    let foi = "";
    if (startingValue.reference) {
      if (startingValue.reference.split("/")[1] && !isNaN(startingValue.reference.split("/")[1])) {
        foi = startingValue.reference.split("/")[1];
      }
    } else if (startingValue.identifier?.system === "https://fevir.net/FLI" &&
      startingValue.identifier.value) {
      let fli = startingValue.identifier.value;
      if (resourceDictionary?.fliToFoi) {
        foi = resourceDictionary["fliToFoi"][fli];
      }
    }
    if (foi && resourceDictionary[foi]) {
      let EvidenceJson = resourceDictionary[foi];
      return createEvidenceDisplay(EvidenceJson);
    }
  }
  return "";
};

const SingleEvidenceEntry = ({ startingValue, addElementValues,
  statisticType, statisticUnit, setEntryInstanceState, numberAnalyzed,
  setReferencedEvidenceRevisedState }) => {

  const evidenceTableMap = useSelector(selectEvidenceTableMap);
  let resourceDictionary = evidenceTableMap.combinedDictionary;
  let evidenceDisplay = getEvidenceDisplay(resourceDictionary, startingValue);

  const [entryState, setEntryState] = useState({});

  useEffect(() => {
    setEntryState({ "entryInstance": startingValue });
  }, [])

  useEffect(() => {
    if (entryState.entryInstance) {
      console.log("If this shows up repeatedly, then a check for change is needed")
      setEntryInstanceState(entryState.entryInstance);
    }
  }, [entryState]);

  return <>
    {evidenceDisplay ?
      <p><b>Summary of Evidence Resource: </b>{evidenceDisplay}</p>
      :
      <>
        <p>Create or select the Evidence Resource. Be sure to click +Add Initial Statistic if doing initial data entry.</p>
      </>}
    {entryState?.entryInstance &&
      <ReferenceEntry elementName='entryInstance' fieldLabel='Reference to this Evidence Resource'
        startingValue={entryState.entryInstance} referencedResourceTypes={["Evidence"]}
        startCollapsed={false} enableCreation={true}
        statisticType={statisticType} statisticUnit={statisticUnit}
        numberAnalyzed={numberAnalyzed}
        startingResourceType={"Evidence"}
        addElementValues={addElementValues}
        setResourceState={setEntryState}
        setReferencedEvidenceRevisedState={setReferencedEvidenceRevisedState} />
    }
  </>
};

const EditTableCellEvidenceOnlyModal = ({ setOpenEditModalState,
  entryInstance, setEntryInstanceState, evidenceTableMapState,
  statisticType, statisticUnit, numberAnalyzed, addElementValues,
  setReferencedEvidenceRevisedState, setEvidenceTableMapState }) => {

  let modalContent = <div style={{
    paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
    paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
  }}>
    <div>
      <div style={{ textAlign: "center" }}>
        <h3 style={{ paddingLeft: "180px" }} >Edit Table Cell Content</h3>
      </div>
      <Button style={{ color: "#FFFFFF", position: "absolute", top: "6px", width: "180px", float: "left" }}
        className="formButton"
        content="Close Modal" positive
        onClick={() => {
          setOpenEditModalState(prevState => { return { ...prevState, openModal: false }; });
        }}
      />
      <Button style={{ padding: "6px", position: "absolute", top: "6px", right: "14px" }}
        className="formButton negative"
        content="✖"
        onClick={() => {
          setOpenEditModalState(prevState => { return { ...prevState, openModal: false }; });
        }} />
    </div>
    <br /><br /><br />
    <div style={{ marginLeft: "24px" }}>
      <SingleEvidenceEntry startingValue={entryInstance}
        statisticType={statisticType} statisticUnit={statisticUnit}
        numberAnalyzed={numberAnalyzed}
        addElementValues={addElementValues}
        setEntryInstanceState={setEntryInstanceState}
        setReferencedEvidenceRevisedState={setReferencedEvidenceRevisedState} />
    </div>
    <br /><br />
    <Button style={{ color: "#FFFFFF", width: "180px", float: "left" }} className="formButton"
      content="Close Modal" positive
      onClick={() => {
        setOpenEditModalState(prevState => { return { ...prevState, openModal: false }; });
      }}
    />
    <br />
  </div>;

  return (
    <Modal
      style={{ padding: "0px", margin: "0px" }}
      dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
      open={true}
      centered={false}
      content={modalContent}
    />
  )
};

export default EditTableCellEvidenceOnlyModal;